import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const EducationConcernsSection = ({
  sessionFormData,
  updateFormData,
  educationLevelError,
  employmentStatusError,
  setEducationLevelError,
  setEmploymentStatusError,
  autoResizeTextarea
}) => {
  return (
    <Card id="education-occupation" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Education & Occupation
      </h3>

      <div style={{ marginBottom: "16px" }}>
        <label className={styles.labelWithMarginXLarge}>
          Highest Education Level
        </label>
        {educationLevelError && (
          <div className={styles.errorMessage}>
            {educationLevelError}
          </div>
        )}
        <div style={{ display: "flex", alignItems: "end", gap: "8px", justifyContent: "space-between" }}>
          <select
            value={sessionFormData.highestEducationLevel || ""}
            onChange={(e) => {
              updateFormData("highestEducationLevel", e.target.value);
              if (educationLevelError) {
                setEducationLevelError("");
              }
              if (e.target.value !== "Other") {
                updateFormData("otherEducationLevelText", "");
              }
            }}
            className={styles.selectMediumWidth}
          >
            <option value="">-</option>
            <option value="Not reported">Not reported</option>
            <option value="Less than high school">Less than high school</option>
            <option value="High school diploma / GED">High school diploma / GED</option>
            <option value="Some college">Some college</option>
            <option value="Associate degree">Associate degree</option>
            <option value="Bachelor's degree">Bachelor's degree</option>
            <option value="Master's degree">Master's degree</option>
            <option value="Doctoral / professional degree">Doctoral / professional degree</option>
            <option value="Trade / vocational training">Trade / vocational training</option>
            <option value="Other">Other</option>
          </select>
          {sessionFormData.highestEducationLevel === "Other" && (
            <div style={{ fontSize: "12px", color: "#8E8E93", whiteSpace: "nowrap" }}>
              {sessionFormData.otherEducationLevelText?.length || 0}/100
            </div>
          )}
        </div>
        {sessionFormData.highestEducationLevel === "Other" && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="other-Education-Level-Text"
              value={sessionFormData.otherEducationLevelText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherEducationLevelText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
              maxLength={100}
            />
          </div>
        )}
      </div>

      <div style={{ marginBottom: "16px" }}>
        <label className={styles.labelWithMarginXLarge}>
          Employment Status
        </label>
        {employmentStatusError && (
          <div className={styles.errorMessage}>
            {employmentStatusError}
          </div>
        )}
        <div style={{ display: "flex", alignItems: "end", gap: "8px", justifyContent: "space-between" }}>
          <select
            value={sessionFormData.employmentStatus || ""}
            onChange={(e) => {
              updateFormData("employmentStatus", e.target.value);
              if (employmentStatusError) {
                setEmploymentStatusError("");
              }
              if (e.target.value !== "Other") {
                updateFormData("otherEmploymentStatusText", "");
              }
            }}
            className={styles.selectMediumWidth}
          >
            <option value="">-</option>
            <option value="Unemployed">Unemployed</option>
            <option value="Not reported">Not reported</option>
            <option value="Employed full-time">Employed full-time</option>
            <option value="Employed part-time">Employed part-time</option>
            <option value="Self-employed">Self-employed</option>
            <option value="Student">Student</option>
            <option value="Retired">Retired</option>
            <option value="Homemaker / caregiver">Homemaker / caregiver</option>
            <option value="Disabled / unable to work">Disabled / unable to work</option>
            <option value="Other">Other</option>
          </select>
          {sessionFormData.employmentStatus === "Other" && (
            <div style={{ fontSize: "12px", color: "#8E8E93", whiteSpace: "nowrap" }}>
              {sessionFormData.otherEmploymentStatusText?.length || 0}/100
            </div>
          )}
        </div>
        {sessionFormData.employmentStatus === "Other" && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="other-Employment-Status-Text"
              value={sessionFormData.otherEmploymentStatusText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherEmploymentStatusText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
              maxLength={100}
            />
          </div>
        )}
      </div>

      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <label className={styles.labelWithMargin}>
            Current Job/Role (if applicable)
          </label>
          <div style={{ marginTop: "4px", fontSize: "12px", color: "#8E8E93" }}>
            {sessionFormData.currentJobRole?.length || 0}/300
          </div>
        </div>
        <textarea
          value={sessionFormData.currentJobRole || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 300) {
              updateFormData("currentJobRole", value);
            }
          }}
          placeholder="Free Text"
          className={styles.textarea}
          maxLength={300}
        />
      </div>
    </Card>
  );
};

export default EducationConcernsSection;

